import React from 'react'

/**
 * @module settings/settings-input-view-only
 * @description A read-only settings field (no Edit link, no onBlur save) --
 * used for account fields a teacher can't change themselves (name, email,
 * account type).
 */
export const SettingsInputViewOnly = ({
	label,
	name,
	value,
	format,
	to,
}) => {
	return (
			<div className="settings-item">
			<div className="field-label-container">
				<span className="field-label">{label}</span>
			</div>
			<input
				className={`field-value`}
				name={name}
				value={(format ? format(value) : value) || ''}
			/>
		</div>
	)
}

export default SettingsInputViewOnly
